module.exports = __webpack_public_path__ + "img/00020.6e2a6531.webp";